import classNames from 'classnames';

import CircularLoadingIndicator from './CircularLoadingIndicator';

type Props = {
  theme?: 'dark' | 'light';
};

const LoadingPlaceholder = ({ theme }: Props) => (
  <div
    className={classNames('flex flex-1 items-center justify-center', {
      'bg-neutral-100': theme === 'light',
    })}
  >
    <CircularLoadingIndicator size="xl" />
  </div>
);

export default LoadingPlaceholder;
